export interface ApiErrorObject {
  code: string;
  details: string;
  messages: string[];
  numeric_code: number;
}

export interface ApiErrorResponse {
  data: string | null;
  error: ApiErrorObject;
  reason: string | null;
  succeed: false | true;
}

export const SERVICE_UNAVAILABLE_ERROR: ApiErrorResponse = {
  succeed: false,
  reason: "SERVICE_UNAVAILABLE",
  data: "",
  error: {
    code: "SERVICE_UNAVAILABLE",
    numeric_code: 503,
    details: "Backend service is unreachable",
    messages: ["سرور در دسترس نیست، لطفاً بعداً تلاش کنید"],
  },
};
